<template>
  <template v-if="display">
    <slot />
  </template>
</template>

<script>
export default {
  name: 'DisplayOnDesktop',

  props: {
    width: {
      type: String,
      default: '1024px'
    }
  },

	data() {
		return {
      deviceMatched: null,
      maxWidth: `(min-width: ${this.width})`
		}
	},

	mounted() {
    this.resizeHandler();
	},

	methods: {
    resizeHandler(e) {
      this.deviceMatched = window.matchMedia(this.maxWidth).matches;
    },
	},
  
	computed: {
    display() {

      if (this.deviceMatched !== null) {
        return this.deviceMatched;
      }

      return false;
    }
  },

  watch: {
    '$screen.width'(width) {
      this.resizeHandler();
    }
  }
}
</script>
